(function ErezReportAmenitiesForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ReportAmenities',
	};

	var form_id = 'reportamenities-';

	$(document).ready(function documentReady() {
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		// vendor name typeahead
		Adzuki.Typeahead(
			$('#' + form_id + 'vendor_name'),
			'/Vendors/search',
			function onSelect(vendor, $self, typeahead) {
				$self.prop('disabled', true);
				$('.reset-vendor-typeahead').removeClass('hidden');
				$('#' + form_id + 'vendor_id').val(vendor.id);
			}
		);

		// client name typeahead
		Adzuki.Typeahead(
			$('#' + form_id + 'client_name'),
			'/Clients/search',
			function onSelect(client, $self, typeahead) {
				$self.prop('disabled', true);
				$('.reset-client-typeahead').removeClass('hidden');
				$('#' + form_id + 'client_id').val(client.id);
			}
		);

		// reset buttons on the typeaheads
		$('.reset-client-typeahead').on('click', function resetTypeahead(e)
		{
			e.preventDefault();

			$('.reset-client-typeahead').addClass('hidden');
			$('#' + form_id + 'client_name').prop('disabled', false);
			$('#' + form_id + 'client_name').val('');
			$('#' + form_id + 'client_id').val('');
		});

		$('.reset-vendor-typeahead').on('click', function resetTypeahead(e)
		{
			e.preventDefault();

			$('.reset-vendor-typeahead').addClass('hidden');
			$('#' + form_id + 'vendor_name').prop('disabled', false);
			$('#' + form_id + 'vendor_name').val('');
			$('#' + form_id + 'vendor_id').val('');
		});
	};
}(jQuery, window.Adzuki || {}));
